import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";
import { SETTINGS } from "@/constants/testIds";

const ROLES = ["business_owner", "manager", "coach", "nutritionist", "yoga_instructor", "barista", "receptionist", "marketing_manager", "finance_manager", "staff"];

export default function Team() {
  const [team, setTeam] = useState([]);
  const [form, setForm] = useState({ name: "", email: "", role: "coach", password: "welcome123" });

  const load = async () => setTeam((await api.get("/tenant/team")).data);
  useEffect(() => { load(); }, []);

  const invite = async (e) => {
    e.preventDefault();
    try {
      const { data } = await api.post("/tenant/team", form);
      toast.success(`Invited ${data.email} · temp password ${data.temp_password}`);
      setForm({ name: "", email: "", role: "coach", password: "welcome123" });
      await load();
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not invite.");
    }
  };

  return (
    <div className="px-4 md:px-8 py-8 max-w-4xl mx-auto">
      <div className="mb-8">
        <div className="text-[10px] uppercase tracking-[0.22em] text-muted-foreground mb-2">Studio</div>
        <h1 className="font-display text-4xl">Team & roles</h1>
        <p className="text-muted-foreground text-sm mt-1">Invite coaches, baristas, managers and more.</p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
        <form onSubmit={invite} className="rounded-xl border border-border bg-card p-6 space-y-3 lg:col-span-1">
          <div className="font-display text-2xl mb-2">Invite member</div>
          <div>
            <Label>Name</Label>
            <Input data-testid={SETTINGS.teamInviteName} value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required className="mt-1.5" />
          </div>
          <div>
            <Label>Email</Label>
            <Input data-testid={SETTINGS.teamInviteEmail} type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} required className="mt-1.5" />
          </div>
          <div>
            <Label>Role</Label>
            <Select value={form.role} onValueChange={(v) => setForm({ ...form, role: v })}>
              <SelectTrigger data-testid={SETTINGS.teamInviteRole} className="mt-1.5"><SelectValue /></SelectTrigger>
              <SelectContent>
                {ROLES.map((r) => <SelectItem key={r} value={r}>{r.replace("_", " ")}</SelectItem>)}
              </SelectContent>
            </Select>
          </div>
          <div>
            <Label>Temporary password</Label>
            <Input value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="mt-1.5 font-mono text-xs" />
          </div>
          <Button data-testid={SETTINGS.teamInviteSubmit} type="submit" className="w-full rounded-full">Send invite</Button>
        </form>

        <div className="lg:col-span-2 rounded-xl border border-border bg-card overflow-hidden">
          <div className="px-5 py-3 border-b border-border text-[10px] uppercase tracking-[0.22em] text-muted-foreground">
            {team.length} members
          </div>
          <ul className="divide-y divide-border">
            {team.map((m) => (
              <li key={m.id} className="px-5 py-4 flex items-center gap-3">
                <div className="h-9 w-9 rounded-full bg-muted grid place-items-center text-sm">
                  {(m.name || "?").slice(0, 1)}
                </div>
                <div className="min-w-0 flex-1">
                  <div className="text-sm font-medium truncate">{m.name}</div>
                  <div className="text-xs text-muted-foreground truncate">{m.email}</div>
                </div>
                <div className="text-[10px] uppercase tracking-[0.22em] rounded-full border border-border px-2 py-0.5">
                  {m.role?.replace("_", " ")}
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
